import { TRUST_RIBBON } from "../lib/data";

export default function Ribbon() {
  const items = [...TRUST_RIBBON, ...TRUST_RIBBON, ...TRUST_RIBBON, ...TRUST_RIBBON];
  return (
    <div className="af-ribbon py-4 overflow-hidden">
      <div className="af-ribbon-track">
        {items.map((label, i) => (
          <div key={i} className="flex items-center gap-12 shrink-0">
            <span className="text-xs lg:text-sm uppercase tracking-[0.25em] text-neutral-300 font-semibold">
              {label}
            </span>
            <span className="text-[#DC2626] text-lg">◆</span>
          </div>
        ))}
      </div>
    </div>
  );
}
